import { Formik } from 'formik';
import { Button, Form, Col, Row } from 'react-bootstrap';
import { TextArea, RankingButton, Modal, Input } from 'components';
import { addReviews } from 'services/reviews/postReviews';
import { useStorage64 } from 'hooks';
import { useState } from 'react';
import { PROFILE_DATA } from 'constants/storage64';
import {
  initialValues,
  STAR_OPTIONS,
  RECOMMENDATION_RATING_OPTIONS,
  schema,
} from './config';
import './styles.scss';
import {useWindowSize} from 'hooks';

export default function ReviewForm({ show, setShow }) {
  const [form, setForm] = useState({});
  const [profileData] = useStorage64(PROFILE_DATA, {});
  const handleSubmit = (values, { resetForm }) => {
    addReviews({
      customer_id: profileData.idClaro,
      customer_name: profileData.nombre,
      customer_email: profileData.correo,
      rating: form.rating,
      title: form.title,
      review: form.review,
      rating_recommendation: form.recommendation,
    }).catch((e) => console.log('error', e));
    setShow(false);
    resetForm({ values: '' });
  };
  const handleClose = () => {
    setShow(false);
  };

  const [,{isMobile}] = useWindowSize()
  return (
    <Formik
      name="formulario"
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {(helpers) => (
          <Modal
              size="lg"
              show={show}
              onClose={handleClose}
              title=""
              titleHeader={isMobile ? "¿Cómo lo hicimos?" : "Escribir reseña"}
              titleHeaderClassName="header d-flex justify-content-center"
              subtitle={!isMobile && "¿Cómo lo hicimos?"}
              subtitleClassName="font-weight-bold pt-1 larger-subtitle"
              withActionButtons={false}
              variant="completed"
              variantOnlyInMobile
              centered
          >
            <div className={!isMobile && ('modal-dialog modal-dialog-centered modal-dialog-scrollable')}>
              <div className="modal-content content">
                <div className={!isMobile && "modal-body"}>
                  <div className={`ReviewForm ${!isMobile && 'container'}`}>
              <Form onSubmit={helpers.handleSubmit}>
                <Row>
                  <Col xs={12}>
                    <p className={!isMobile && "text-center"}>Nos encantaría saber de ti</p>
                  </Col>
                  <Col xs={12}>
                    <Input
                        className="inputborder"
                        label="Título de tu reseña"
                        placeholder="Titulo"
                        name="title"
                        onChange={(value) => {
                          setForm({ ...form, title: value.target.value });
                        }}
                    />
                  </Col>

                  <Col xs={12}>
                    <RankingButton
                        label="¿Cómo fue tu experiencia en nuestro sitio?"
                        name="reviewStars"
                        options={STAR_OPTIONS}
                        variant="stars"
                        onChange={(value) => {
                          setForm({ ...form, rating: value.target.value });
                        }}
                    />
                  </Col>
                  <Col xs={12} className="mt-2">
                    <TextArea
                        className="inputborder"
                        placeholder="Comparte cómo podemos mejorar"
                        name="review"
                        onChange={(value) => {
                          setForm({ ...form, review: value.target.value });
                        }}
                    />
                  </Col>
                  <Col xs={12}>
                    <RankingButton
                        groupClassName="my-2"
                        label="¿Qué posibilidades hay que nos recomiendes con familiares y amigos?"
                        name="recommendationRating"
                        options={RECOMMENDATION_RATING_OPTIONS}
                        onChange={(value) => {
                          setForm({ ...form, recommendation: value.target.value });
                        }}
                    />
                  </Col>
                  <Col xs={12} className={`px-4 mb-2 ${isMobile ? 'mt-5' : 'mt-3'}`}>
                    <Button block type="submit">
                      Enviar
                    </Button>
                  </Col>
                </Row>
              </Form>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
      )}
    </Formik>
  );
}
